/**
 * /tenants/$slug/audit — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  auditListSearchSchema,
  type AuditListSearch,
} from "@/features/audit/schemas";
import { fetchTenantAudit, fetchWindowsAuthentications } from "@/features/audit/queries";
import { queryKeys } from "@/lib/query-keys";
import { TenantAuditPage } from "@/features/audit/pages/audit-page";

export const Route = createFileRoute("/_authed/tenants/$slug/audit/")({
  validateSearch: (raw: Record<string, unknown>): AuditListSearch =>
    auditListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) => {
    // The compliance views under Audit fetch through their own hooks.
    if (deps.search.view === "evidence" || deps.search.view === "signed-records") {
      return undefined;
    }
    if (deps.search.view === "windows-authentication") {
      return context.queryClient.ensureQueryData({
        queryKey: queryKeys.audit.windowsAuthentications(context.tenant.id, deps.search),
        queryFn: () => fetchWindowsAuthentications(context.tenant.id, deps.search),
      });
    }
    return context.queryClient.ensureQueryData({
      queryKey: queryKeys.audit.tenantEvents(context.tenant.id, deps.search),
      queryFn: () => fetchTenantAudit(context.tenant.id, deps.search),
    });
  },
  component: TenantAuditPage,
});
